<script setup>
import SkeletonLoad from '../../components/SkeletonLoad.vue';
import emitter from '../../assets/js/eventBus';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();


defineProps({
  rowReverse: {
    type: Boolean,
    default: false,
  },
  title: {
    type: [Object, String],
    required: true,
    text: {
      type: String,
    },
    color: {
      type: String,
    },
  },
  description: {
    type: String,
    default: "",
  },
  value: {
    type: [Object, String, Number],
    required: true,
    text: {
      type: [String, Number],
    },
    color: {
      type: String,
    },
  },
  future_value: {
    type: [Object, String, Number],
    required: true,
    text: {
      type: [String, Number],
    },
    color: {
      type: String,
    },
  },
  icon: {
    type: [String, Object],
    component: {
      type: String,
    },
    background: {
      type: String,
    },
    shape: {
      type: String,
    },
    default: () => ({
      background: "bg-white",
      shape: " border-radius-md",
    }),
  },
  classContent: {
    type: String,
    default: "",
  },
  loading: {
    type: Boolean,
    default: true,
  },
});

function formatMoney(v) {
      let total = parseFloat(v);

      return total.toLocaleString(t('message.global.date_language'), {
        style: "currency",
        currency: "BRL",
      });
    }

const openType = (type) => {
    emitter.emit('set-type', { data: type });
}
</script>
<template>
  <div class="mb-3 card shadow mini-stat-card-root">
    <div class="p-3 card-body mini-stat-card-body">
      <div
        class="d-flex row mini-stat-grid"
        :class="rowReverse ? '' : 'flex-row-reverse justify-content-between'"
      >
        <div
          class="text-center shadow icon icon-shape align-self-center col-2 mini-stat-icon"
          v-if="title.text === 'Despesa'"
          data-bs-toggle="modal" data-bs-target="#addTransaction" @click="openType('despesa')"
          :class="[
            typeof icon === 'object'
              ? `${icon.background} ${icon.shape}`
              : 'border-radius-md',
            rowReverse ? 'ms-1 me-n2' : '',
          ]"
        >
          <i
            class="text-lg opacity-10"
            :class="typeof icon === 'string' ? icon : icon.component"
            aria-hidden="true"
          ></i>
        </div>
        <div
          class="text-center shadow icon icon-shape align-self-center col-2 mini-stat-icon"
          v-else-if="title.text === 'Receita'"
          data-bs-toggle="modal" data-bs-target="#addTransaction" @click="openType('receita')"
          :class="[
            typeof icon === 'object'
              ? `${icon.background} ${icon.shape}`
              : 'border-radius-md',
            rowReverse ? 'ms-1 me-n2' : '',
          ]"
        >
          <i
            class="text-lg opacity-10"
            :class="typeof icon === 'string' ? icon : icon.component"
            aria-hidden="true"
          ></i>
        </div>
        <div
          class="text-center shadow icon icon-shape align-self-center col-2 mini-stat-icon"
          v-else
          :class="[
            typeof icon === 'object'
              ? `${icon.background} ${icon.shape}`
              : 'border-radius-md',
            rowReverse ? 'ms-1 me-n2' : '',
          ]"
        >
          <i
            class="text-lg opacity-10"
            :class="typeof icon === 'string' ? icon : icon.component"
            aria-hidden="true"
          ></i>
        </div>
        <div class="col-10 col-xxl-12 mt-xxl-2 mini-stat-content">
          <div class="row">
            <div class="col-6">
              <p
                class="mb-0 ms-1 ms-xxl-0 font-weight-bold text-dark mini-stat-title"
              >
                {{ typeof title === "string" ? title : title.text }}
              </p>
              <span class="text-sm ms-1 ms-xxl-0">{{t('message.global.predicted')}}</span>
            </div>
            <div class="col-6 text-end">
              <SkeletonLoad
                  v-if="loading"
                  :width="'110px'"
                  :height="'25px'"
              />
              <h6 v-else :class="`mb-0 font-weight-bolder text-dark mini-stat-value ${value.color}`">
                {{
                  (value && typeof value === "string") ||
                  (value && typeof value === "number")
                    ? formatMoney(value)
                    : formatMoney(value.text)
                }}
                
              </h6>
              <span class="text-sm mini-stat-future" v-if="!loading">
              {{
                (future_value && typeof future_value === "string") ||
                (future_value && typeof future_value === "number")
                  ? formatMoney(future_value)
                  : formatMoney(future_value.text)
              }}
            </span>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <div class="col-12 mt-n2 mb-1">
      
    </div>
  </div>
</template>


<style scoped>
.mini-stat-card-root{
  border-radius: 24px;
}

.mini-stat-card-body{
  padding: 1rem 1rem !important;
}

.mini-stat-title{
  color:#31486d !important;
  font-weight:800;
  line-height:1.1;
}

.mini-stat-value{
  color:#31486d !important;
  font-weight:900;
  line-height:1.05;
  white-space: nowrap;
}

.mini-stat-future{
  color:#94a3b8 !important;
  font-weight:500;
  line-height:1.15;
}

@media (max-width: 767.98px){
  .mini-stat-card-body{
    padding: 0.9rem 0.95rem !important;
  }

  .mini-stat-icon{
    width: 44px !important;
    height: 44px !important;
    min-width: 44px !important;
    min-height: 44px !important;
  }

  .mini-stat-grid{
    align-items:center !important;
  }

  .mini-stat-content{
    padding-left: 0.35rem !important;
  }

  .mini-stat-title{
    font-size: 0.98rem !important;
    margin-bottom: 0.18rem !important;
  }

  .mini-stat-value{
    font-size: 1.15rem !important;
  }

  .mini-stat-future,
  .mini-stat-predicted{
    font-size: 0.82rem !important;
  }
}
</style>
